import React from 'react';
import {connect} from 'react-redux';
import SingleVATNumberSelector from '../selectors/vatNumber/SingleVATNumberSelector';
import Logger, {LOG_LEVELS} from '../../utils/logger';
import Underscore from "underscore";
import DATES from "../../utils/formattedDates";
import GlobalFilterPanel, {FILTER_PERIOD_GROUP}  from '../filter/GlobalFilterPanel';
import GLOBAL_FILTER_CONTROLLER from '../../controllers/globalFilter';
import DataMiningCommonFilterPanel from '../dataMining/DataMiningCommonFilterPanel';
import UK_MTD_VAT_CONTROLLER from '../../controllers/ukMTDVAT';
import {TransactionReportTypeEnum} from '../../utils/enums';
import _ from 'lodash';
const log = new Logger('MAKING_TAX_DIGITAL_FILTERPANEL', LOG_LEVELS.DEBUG);

let vatNumbersArray = [];
let today = DATES.getTodayFormatted('yyyy-mm-dd');

export class FilterPanel extends React.Component {

  constructor(props) {
    super(props);
      this.state = {
          vatNumberArray: [],
          disableSearch: true,
          selection: {
              vatnumber: '',
              companyId: 0
          }};
      this.handleChangeVATNumber = this.handleChangeVATNumber.bind(this);
      this.handleChangeCompany = this.handleChangeCompany.bind(this);
      this.onReportChangeHandler = this.onReportChangeHandler.bind(this);
      this.onSearchClick = this.onSearchClick.bind(this);
  }
    onSearchClick(selection) {
        log.debug('onSearchClick(): state.selection: ', this.state.selection);
        log.debug('onSearchClick(): selection: ', selection);
        let combinedSelection = Object.assign({}, this.state.selection, selection);
        log.debug('onSearchClick(): combinedSelection: ', combinedSelection, this.props.reportTypeSelected);
        switch(this.props.reportTypeSelected)
        {
           case TransactionReportTypeEnum.MTDLIABILITY.value: {
               if (this.props !== undefined && typeof this.props.doGetVATLiabilities === 'function')
                   this.props.doGetVATLiabilities(combinedSelection);
               break;
           }
            case TransactionReportTypeEnum.MTDPAYMENTS.value: {
                if (this.props !== undefined && typeof this.props.doGetVATPayments === 'function')
                    this.props.doGetVATPayments(combinedSelection);
                break;
            }
            case TransactionReportTypeEnum.MTDRETURNS.value: {
                if (this.props !== undefined && typeof this.props.doGetObligations === 'function')
                    this.props.doGetObligations(combinedSelection);
                break;
            }
        }
        this.props.onSearchClick(combinedSelection);
    }
    onReportChangeHandler(selection = {}) {
        log.debug('onReportChangeHandler reportType', selection.reportType);
        this.props.onReportTypeChange(selection);
    }
    handleChangeVATNumber(keyValuePairs) {
        let value = '',i ;
        for(i in keyValuePairs) { value = keyValuePairs[i] }
        log.debug('handleChangeVATCode(%s): %s, ', 'vatnumber',value);
        let selection = Object.assign({}, this.state.selection);
        selection.vatnumber = value;

        let disableSearch = false;
        if(selection.vatnumber === undefined)
            disableSearch = true;

        this.setState({
            selection: selection,
            disableSearch: disableSearch
        });

        log.debug('handleChangeVATNumber ', this.state.disableSearch,disableSearch);
    }
    handleChangeCompany(keyValuePairs) {
        let selection = Object.assign({}, this.state.selection);
        let disableSearch = Underscore.isEmpty(selection);
        this.setState({
            disableSearch: disableSearch
        });


      let value = '',i;
        for(i in keyValuePairs) {
            log.debug('handleChangeCompany ', i);
            //Gets call for date change as well
            if(i !== 'companyId')
                return;
            value = keyValuePairs[i] }

        //Set selected companyId in state to filter VAT numbers by selected company id
        selection.companyId = value;
        this.setState({
            selection: selection
        });
        if(this.props !== undefined && this.props.compnayList!== undefined) {
                vatNumbersArray = this.getVatNumbers(this.props.compnayList,value);
                selection.vatnumber = ''
                this.setState({selection: selection,vatNumberArray : vatNumbersArray});
            }
        }


    getVatNumbers(compnayList,companyId)
    {
        if(compnayList!== undefined) {
            let filteredCompanyVATNumbers = Underscore.where(compnayList, {"id": Number(companyId)});

            if (filteredCompanyVATNumbers !== undefined && filteredCompanyVATNumbers.length > 0) {
                let filteredCountryVATNumbers = Underscore.where(filteredCompanyVATNumbers[0]['vatNumbers'], {"vatnumberCountry": "GB"});
                let vatNumbersArrayLocalNonUnique = Underscore.map(filteredCountryVATNumbers, function (item) {
                    return item['vatnumber'];
                });
                return Underscore.uniq(vatNumbersArrayLocalNonUnique);
            }
        }
    }

  render() {
    log.debug('render(): ', this.props,this.state.disableSearch);
      const globalFilterSetting ={
          hideElements: {
              countryCode: true,
              month: true,
              year: true,
              returnType: true,
              returnStatus: true
          },
          filterPeriodGroup: FILTER_PERIOD_GROUP.DATE_RANGE,
          onFieldChange: this.handleChangeCompany,
          onSearchClick: this.onSearchClick,
          disableSearch: this.state.disableSearch
  };
      //Get vatNumbers list
      let vatNumberArray = [];
      if((this.state.vatNumberArray === undefined || this.state.vatNumberArray.length === 0) &&
          this.props.compnayList !== undefined && this.props.compnayList.length > 0 && this.state.selection.companyId != 'All')
      {

          let globalFilterSelection = GLOBAL_FILTER_CONTROLLER.getAll();
          if(!Underscore.isEmpty(globalFilterSelection) && globalFilterSelection.companyId !== undefined) {
              //Global filter value updated after apply, hence if company selection changed take value from state
              let companyId = (this.state.selection.companyId !== undefined && this.state.selection.companyId > 0 )?
                                this.state.selection.companyId :
                                globalFilterSelection.companyId;
              vatNumberArray = this.getVatNumbers(this.props.compnayList, companyId);
          }
      }
    return (
        <s-box name="filter-panel"  data-test="component-filter-panel">
            <GlobalFilterPanel {...globalFilterSetting}>
                <SingleVATNumberSelector
                    fieldName={"vatNumber"}
                    selectionHandler={this.handleChangeVATNumber}
                    selectedVATNumberId={this.state.selection.vatnumber || this.props.vatNumber || ''}
                    VATNumberList={!_.isEmpty(this.state.vatNumberArray) && this.state.vatNumberArray.length > 0 ? this.state.vatNumberArray : vatNumberArray}
                />
                <DataMiningCommonFilterPanel
                    reportType={this.props.reportTypeSelected}
                    onReportTypeChange={this.onReportChangeHandler}
                />
            </GlobalFilterPanel>
            <div className="clear"></div>
        </s-box>
    )
  }
}

function mapStateToProps(state) {
  log.debug('mapStateToProps: ', state);  
  return {
    languages: state.languages,
      compnayList : (state.companies && state.companies.data) || []
  };
}
function mapDispatchersToProps(dispatch) {
    return {
        doGetObligations: (queryParams) => {
            log.debug('doGetObligations', queryParams);
            if(queryParams.vatnumber !== undefined && !Underscore.isEmpty(queryParams.vatnumber ))
                dispatch(UK_MTD_VAT_CONTROLLER.doGetObligations(queryParams));
        },
        doGetVATLiabilities: (queryParams) => {
            log.debug('doGetVATLiabilities', queryParams);
            if(queryParams.vatnumber !== undefined && !Underscore.isEmpty(queryParams.vatnumber ))
                dispatch(UK_MTD_VAT_CONTROLLER.doGetVATLiabilities(queryParams));
        },
        doGetVATPayments: (queryParams) => {
            log.debug('doGetVATPayments', queryParams);
            if(queryParams.vatnumber !== undefined && !Underscore.isEmpty(queryParams.vatnumber ))
                dispatch(UK_MTD_VAT_CONTROLLER.doGetVATPayments(queryParams));
        }
    }
}



export default connect(mapStateToProps,mapDispatchersToProps)(FilterPanel);